export const navLinks = [
  {
    name: "Home",
    path: "/",
  },
  {
    name: "Royalties",
    path: "/royalties",
  },
  {
    name: "NFT viewer",
    path: "/nftviewer",
  },
  {
    name: "Team",
    path: "/team",
  },
];

export const socialLinks = [
  {
    name: "Discord",
    path: "https://discord.gg/mkmNJXTpNm",
  },
  {
    name: "Twitter",
    path: "https://twitter.com/CronosNightOwls",
  },
];
export const Links = [
  {
    name: "Marketplace",
    path: "https://app.ebisusbay.com/collection/the-cronos-night-owls",
  },
  {
    name: "Rarity Sniper",
    path: "https://raritysniper.com/the-cronos-night-owls",
  },
  {
    name: "KYC Proof",
    path: "https://phenix.finance/projects/the-cronos-night-owls/",
  },
];
